export const ERROR_PAGE = {
  TITLE: 'Error',
  UNEXPECTED_ERROR: 'Ocurrió un error inesperado',
}
